if (!customElements.get('screen-saver')) {
  class ScreenSaver extends HTMLElement {
    connectedCallback() {
      this.style.display = '';
      this._randomizeImageSizes();

      if (window.Shopify && window.Shopify.designMode) return;

      this.idleTime = parseInt(this.dataset.idleTime, 10) || 60000;
      this.showOnTabLeave = this.dataset.showOnTabLeave !== 'false';
      this._idleTimer = null;
      this._hiddenByTab = false;

      const speed = (parseInt(this.dataset.speed, 10) || 100) / 100;
      this.style.setProperty('--ss-speed', speed);
      this._onActivity = this._onActivity.bind(this);
      this._onVisibilityChange = this._onVisibilityChange.bind(this);

      this.addEventListener('click', () => this._deactivate());

      this._startTimer();

      ['mousemove', 'keydown', 'touchstart', 'scroll'].forEach((ev) => {
        document.addEventListener(ev, this._onActivity, { passive: true });
      });

      document.addEventListener('visibilitychange', this._onVisibilityChange);
    }

    disconnectedCallback() {
      clearTimeout(this._idleTimer);

      ['mousemove', 'keydown', 'touchstart', 'scroll'].forEach((ev) => {
        document.removeEventListener(ev, this._onActivity);
      });

      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }

    _randomizeImageSizes() {
      this.querySelectorAll('.screen-saver__track img').forEach((img) => {
        const size = Math.floor(Math.random() * 101) + 50;
        img.style.maxWidth = `${size}px`;
        img.style.maxHeight = `${size}px`;
      });
    }

    _startTimer() {
      clearTimeout(this._idleTimer);
      this._idleTimer = setTimeout(this._activate.bind(this), this.idleTime);
    }

    _activate() {
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
      this.classList.add('active');
    }

    _deactivate() {
      this.classList.remove('active');
      this._hiddenByTab = false;
      this._startTimer();
    }

    _onActivity() {
      if (this.classList.contains('active')) {
        this._deactivate();
      } else {
        this._startTimer();
      }
    }

    _onVisibilityChange() {
      if (!this.showOnTabLeave) return;

      if (document.hidden) {
        this._hiddenByTab = true;
        this._activate();
      } else if (this._hiddenByTab) {
        this._deactivate();
      }
    }
  }

  customElements.define('screen-saver', ScreenSaver);
}
